export function getNoSearchResultsMessage(filterText: string): string {
  return `Your search for “${filterText}” didn’t return any results. Try another search.`;
}
